import type { RouteRecordRaw } from 'vue-router'

// 总平台路由配置
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/views/platform/PlatformPlatform.vue'),
    redirect: '/dashboard',
    children: [
      // 1. 首页/仪表盘
      {
        path: 'dashboard',
        name: 'PlatformDashboard',
        component: () => import('@/views/platform/pages/Dashboard.vue'),
        meta: { title: '平台概览', icon: 'dashboard', permissions: ['*:platform:*:view'] }
      },

      // 2. 登录页面（独立页面，不在侧边栏）
      {
        path: 'login',
        name: 'PlatformLogin',
        component: () => import('@/views/platform/pages/Login.vue'),
        meta: { title: '登录', hidden: true }
      },

      // 3. 注册页面（独立页面，不在侧边栏）
      {
        path: 'register',
        name: 'PlatformRegister',
        component: () => import('@/views/platform/pages/Register.vue'),
        meta: { title: '注册', hidden: true }
      },

      // 4. 忘记密码页面（独立页面，不在侧边栏）
      {
        path: 'forgot',
        name: 'PlatformForgot',
        component: () => import('@/views/platform/pages/Forgot.vue'),
        meta: { title: '忘记密码', hidden: true }
      },

      // 5. 个人中心
      {
        path: 'profile',
        name: 'PlatformProfile',
        component: () => import('@/views/platform/pages/Profile.vue'),
        meta: { title: '个人中心', icon: 'user', permissions: ['*:platform:profile:view'] }
      },

      // 6. 消息中心
      {
        path: 'messages',
        name: 'PlatformMessages',
        component: () => import('@/views/platform/pages/Messages.vue'),
        meta: { title: '消息中心', icon: 'message', permissions: ['*:platform:messages:view'] }
      },

      // 7. 权限管理
      {
        path: 'permission',
        name: 'PlatformPermission',
        component: () => import('@/views/platform/pages/Permission.vue'),
        meta: { title: '权限管理', icon: 'lock', permissions: ['*:platform:permission:manage'] }
      },

      // 8. 操作审计
      {
        path: 'audit',
        name: 'PlatformAudit',
        component: () => import('@/views/platform/pages/Audit.vue'),
        meta: { title: '操作审计', icon: 'audit', permissions: ['*:platform:audit:view'] }
      },

      // ========== 开放平台（第四层） ==========
      // 9. API管理
      {
        path: 'open/api',
        name: 'PlatformOpenApi',
        component: () => import('@/views/platform/open/ApiManagement.vue'),
        meta: { title: 'API管理', hidden: true }
      },
      // 10. 应用市场
      {
        path: 'open/market',
        name: 'PlatformOpenMarket',
        component: () => import('@/views/platform/open/AppMarket.vue'),
        meta: { title: '应用市场', hidden: true }
      },
      // 11. Webhook配置
      {
        path: 'open/webhook',
        name: 'PlatformOpenWebhook',
        component: () => import('@/views/platform/open/WebhookConfig.vue'),
        meta: { title: 'Webhook配置', hidden: true }
      },
      // 12. 开发者文档
      {
        path: 'open/docs',
        name: 'PlatformOpenDocs',
        component: () => import('@/views/platform/open/DeveloperDocs.vue'),
        meta: { title: '开发者文档', hidden: true }
      },

      // ========== 内部管理平台（第五层） ==========
      // 13. 租户管理
      {
        path: 'internal/tenant',
        name: 'PlatformInternalTenant',
        component: () => import('@/views/platform/internal/TenantManagement.vue'),
        meta: { title: '租户管理', hidden: true }
      },
      // 14. 计量计费
      {
        path: 'internal/billing',
        name: 'PlatformInternalBilling',
        component: () => import('@/views/platform/internal/BillingMetrics.vue'),
        meta: { title: '计量计费', hidden: true }
      },
      // 15. SLA监控
      {
        path: 'internal/sla',
        name: 'PlatformInternalSla',
        component: () => import('@/views/platform/internal/SlaMonitor.vue'),
        meta: { title: 'SLA监控', hidden: true }
      },
      // 16. 工单流转
      {
        path: 'internal/ticket',
        name: 'PlatformInternalTicket',
        component: () => import('@/views/platform/internal/TicketWorkflow.vue'),
        meta: { title: '工单流转', hidden: true }
      }
    ]
  }
]

export const platformRoutes = routes

export default routes